exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.mx-datepicker input { height: calc(2.375rem + 2px);\n}\n.mx-datepicker {width: 120px;}", ""]);

// exports
